import axios from "axios";
import api from "./api";
export default class VendasBoletoIndividualApi {
  static postVendaBolePix = async (body: any) => {
    const response = await api.post(`/bolepix/gerar-avulso`, body);
    return response.data;
  };
}
